module.exports = __webpack_public_path__ + "static/media/banner.73c4424b.png";